import { useTexture } from "@react-three/drei";
import { useStore } from "../../../store";
import React, { FC } from "react";
import { SMALL } from "../utils";

export const SmallTerminalFrame: FC = () => {
  const url = useStore((s) => s.assetUrl);
  const texture = useTexture(url("/assets/textures/ui/c_system_small.svg"));

  return (
    <mesh castShadow receiveShadow>
      <boxGeometry args={SMALL.toArray()} />
      <meshPhongMaterial map={texture} transparent={true} />
    </mesh>
  );
};
